import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import cx from 'classnames';
import PublicPagesNav from './PublicPagesNav';
import HeaderCart from './HeaderCart';
import FeatureFlags from '../../util/featureFlags';

const PublicHeader = ({ name, weddingDate, hashtag, location, slug, pages, cartSize, onCart }) => {
  const className = cx('hashtag', {
    'hashtag--with-cart': cartSize > 0 && FeatureFlags.get('persistentCart'),
  });

  return (
    <header id="public-page-header" className="clearfix">
      <div id="public-page-details" className="top-row hidden-xs hidden-sm">
        {weddingDate && <h5 className="wedding-date">{weddingDate}</h5>}
        {location && <h5 className="wedding-location">{location}</h5>}
        {hashtag && <h5 className={className}>#{hashtag}</h5>}
      </div>
      <div className="col-xs-12 website-title">
        <h1 id="public-page-title" className="hidden visible-md visible-lg">
          <Link to={`/wedding/${slug}`}>{name}</Link>
        </h1>
        <PublicPagesNav pages={pages} slug={slug} />
        <h1 className="hidden visible-xs visible-sm">
          <Link to={`/wedding/${slug}`}>{name}</Link>
        </h1>
        <HeaderCart cartSize={cartSize} onCart={onCart} classNames="hidden-md hidden-lg" />
      </div>
    </header>
  );
};

PublicHeader.propTypes = {
  cartSize: PropTypes.number,
  onCart: PropTypes.func,
  name: PropTypes.string.isRequired,
  weddingDate: PropTypes.string,
  hashtag: PropTypes.string,
  location: PropTypes.string,
  slug: PropTypes.string.isRequired,
  pages: PropTypes.arrayOf(PropTypes.shape({})),
};

export default PublicHeader;
